"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentAge = CurrentAge;
exports.FutureGroceriesAndDiningOut = FutureGroceriesAndDiningOut;
exports.FutureHealthcareAndInsurance = FutureHealthcareAndInsurance;
exports.FutureHousingAndInsurance = FutureHousingAndInsurance;
exports.FuturePersonalAndMiscellaneous = FuturePersonalAndMiscellaneous;
exports.FutureTransportationAndInsurance = FutureTransportationAndInsurance;
exports.FutureTravelAndEntertainment = FutureTravelAndEntertainment;
exports.GroceriesAndDiningOut = GroceriesAndDiningOut;
exports.GroceriesInflation = GroceriesInflation;
exports.HealthcareAndInsurance = HealthcareAndInsurance;
exports.HealthcareInflation = HealthcareInflation;
exports.HousingAndInsurance = HousingAndInsurance;
exports.HousingInflation = HousingInflation;
exports.OtherIncome = OtherIncome;
exports.Pension = Pension;
exports.PersonalAndMiscellaneous = PersonalAndMiscellaneous;
exports.PersonalInflation = PersonalInflation;
exports.RetirementAge = RetirementAge;
exports.SocialSecurityBenefit = SocialSecurityBenefit;
exports.TransportationAndInsurance = TransportationAndInsurance;
exports.TransportationInflation = TransportationInflation;
exports.TravelAndEntertainment = TravelAndEntertainment;
exports.TravelInflation = TravelInflation;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CurrentAge(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'currentAge';
  var label = 'Current Age';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "2",
    placeholder: "0",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function RetirementAge(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'retirementAge';
  var label = 'Retiring Age';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "2",
    placeholder: "0",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function SocialSecurityBenefit(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'socialSecurityBenefit';
  var label = 'Social Security /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Pension(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'pension';
  var label = 'Pension /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function OtherIncome(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'otherIncome';
  var label = "Other Expected Monthly Income";
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    popoverText: _RetirementIncomeGapWizardCalc.popoverConfig.otherIncome
  });
}
function HousingAndInsurance(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'housingAndInsuranceCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Housing /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HealthcareAndInsurance(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'healthcareAndInsuranceCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Healthcare /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function TransportationAndInsurance(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'transportationAndInsuranceCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Transportation /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function PersonalAndMiscellaneous(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'personalAndMiscellaneousCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Personal & Miscellaneous /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function TravelAndEntertainment(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'travelAndEntertainmentCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Travel & Entertainment /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function GroceriesAndDiningOut(props) {
  var {
    errors,
    touched,
    values,
    onClick
  } = props;
  var fieldName = 'groceriesAndDiningOutCost';
  var label = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Groceries & Eating Out /month ", /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mouse-pointer mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Edit Itemized List")));
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FutureHousingAndInsurance(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_housingAndInsuranceCost';
  var label = 'Housing /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FutureHealthcareAndInsurance(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_healthcareAndInsuranceCost';
  var label = 'Healthcare /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FutureTransportationAndInsurance(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_transportationAndInsuranceCost';
  var label = 'Transportation /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FuturePersonalAndMiscellaneous(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_personalAndMiscellaneousCost';
  var label = 'Personal & Miscellaneous /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FutureTravelAndEntertainment(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_travelAndEntertainmentCost';
  var label = 'Travel & Entertainment /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FutureGroceriesAndDiningOut(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'future_groceriesAndDiningOutCost';
  var label = 'Groceries & Eating Out /month';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HousingInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'housingExpenses';
  var label = 'Housing Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HealthcareInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'healthCareAndInsuranceExpenses';
  var label = 'Healthcare Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function TransportationInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'transportationExpenses';
  var label = 'Transportation Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function GroceriesInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'groceriesAndEatingOutExpenses';
  var label = 'Groceries & Eating Out Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function TravelInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'travelAndEntertainmentExpenses';
  var label = 'Travel & Entertainment Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function PersonalInflation(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'personalExpenses';
  var label = 'Personal & Miscellaneous Inflation Rate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}